import { ArrowLeftOutlined } from "@ant-design/icons";
import { Space, Typography, Button, List, Spin } from "antd";
import EventDrawer from "components/EventDrawer/EventDrawer";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentBooking } from "redux/actions/booking.actions";
import { addonsTextReducer, convertMinsToHrsMins } from "utils/common";

import styles from "./ProfileDrawer.module.scss";
import useCustomerBookingsInfo from "hooks/useCustomerBookingsInfo";
import { setFetchingCustomerBookings } from "redux/actions/customerInfo.actions";
import { getCustomerNoShowBookings, getCustomerTotalBookings, getCustomerUpcomingBookings } from "services/booking.service";

const { Title, Text } = Typography;
const OrderStatus = {
  Pending: 1,
  Cancel: 2,
  Completed: 3,
  "No Show": 4,
  Arrived: 5,
};
const AppointmentCard = ({ appointment, onClick }) => {
  const { orderId, orderStatus, orderStatusString, formattedServicesWithBoostsStringWithDuration, formattedServicesWithBoostsString } = appointment;
  const getOrderStatus = (statusId, order) => {
    for (const key in OrderStatus) {
      if (statusId === OrderStatus[key]) {
        return key;
      }
    }
  };
  // TODO: DONT USE ORDERSTATUS_STRING
  let statusColor = "";
  if (orderStatusString === "Pending") {
    statusColor = "#27ca2d";
  } else if (orderStatusString === "Arrived") {
    statusColor = "#27ca2d";
  } else if (orderStatusString === "NoShow") {
    statusColor = " #fa8c16";
  } else if (orderStatusString === "Cancel") {
    statusColor = " #fa8c16";
  } else if (orderStatusString === "Completed") {
    statusColor = "#27ca2d";
  } else if (orderStatusString !== "Arrived") {
    statusColor = "#486baf ";
  }

  return (
    <div className="ppointmentCard">
      <Title
        level={5}
        style={{
          color: "#486BAF",
          cursor: "pointer",
        }}
        onClick={() => onClick(appointment)}
      >
        {formattedServicesWithBoostsString}
      </Title>
      <Space direction="vertical">
        <Text>
          {moment(appointment.serviceDate).format("MMMM, DD YYYY - h:mm a")}
        </Text>
        <Text style={{ fontSize: 14 }}>
          Status:{" "}
          <b
            style={{
              color: statusColor,
            }}
          >
            {getOrderStatus(orderStatus) === "Cancel"
              ? "Cancelled"
              : getOrderStatus(orderStatus)}
          </b>
        </Text>
      </Space>
    </div>
  );
};

export default function AppointmentsTab({ customerId, status, onClose, onSave }) {
  // useEffect(() => {}, [status]);
  const dispatch = useDispatch();

  const [showAppointment, setShowAppointment] = useState(false);
  // const refreshCustomerBookingData = useCustomerBookingsInfo(customerId, false);
  const { customerInfo } = useSelector((state) => state);
  const { totalBookings, upcomingBookings, noShowBookings, isFetching } =
    customerInfo;
  let renderList = totalBookings;
  if (status === 1) renderList = upcomingBookings;
  else if (status === 3) renderList = noShowBookings;


  const handleRefreshAppointments = useCallback(() => {
    dispatch(setFetchingCustomerBookings(true));

    if (status === 1) {
      dispatch(getCustomerUpcomingBookings(customerId)).finally(() => {
        dispatch(setFetchingCustomerBookings(false));
      });
    } else if (status === 3) {
      dispatch(getCustomerNoShowBookings(customerId)).finally(() => {
        dispatch(setFetchingCustomerBookings(false));
      });
    } else {
      dispatch(getCustomerTotalBookings(customerId)).finally(() => {
        dispatch(setFetchingCustomerBookings(false));
      });
    }
  }, [customerId, status])

  return (
    <div className={styles.appointmentTabContainer}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 0px",
          borderBottom: "2px solid rgb(239, 241, 244)",
        }}
      >
        <Button
          shape="circle"
          icon={<ArrowLeftOutlined />}
          style={{
            border: "none",
            marginRight: 4,
          }}
          onClick={() => onClose()}
        />

        <Title level={4} style={{ marginBottom: 0 }}>
          {status === 0 && "Total Appointments"}
          {status === 1 && "Upcoming Appointments"}
          {status === 3 && "No Shows"} {isFetching && <Spin />}
        </Title>
      </div>
      <List
        style={{
          height: "calc(100vh - 104px - 54px)",
          height: "calc(100dvh - 104px - 54px)",
          overflowY: "scroll",
        }}
        className="customerAppointmentsList"
        itemLayout="vertical"
        size="large"
        dataSource={renderList}
        renderItem={(appointment, index) => (
          <List.Item key={index}>
            <AppointmentCard
              key={appointment.orderId ?? index}
              appointment={appointment}
              onClick={async (booking) => {
                await dispatch(setCurrentBooking(booking));
                setShowAppointment(true);
              }}
            />
          </List.Item>
        )}
      />
      <EventDrawer
        visible={showAppointment}
        onClose={() => {
          setShowAppointment(false);
          onSave?.()
          handleRefreshAppointments?.()
          // refreshCustomerBookingData();
        }}
        setShowEventDrawer={(visible) => {
          setShowAppointment(visible);
          onSave?.()
          handleRefreshAppointments?.()
          // refreshCustomerBookingData();
        }}
      // getData={() => {
      //   console.log("getData",);
      //   refreshCustomerBookingData();
      // }}
      />
    </div>
  );
}
